require("jquery")
require("jquery-ui")
require("blueimp-file-upload")


$(document).ready(function() {
  if ($(".password-recovery-form").length) { return false; }


  function sanitizePhoneNumber(input) {
    var number = input.value;
    number = number.replace(/\s/g, "");
    var valid = /^\d{9}$/.test(number)
    if (/^\d+$/.test(number)) {
      input.value = number.match(/.{1,3}/g).join(" ")
    }
    return valid;
  }

  function sanitizeVerificationCode(input) {
    var number = input.value;
    number = number.replace(/\s/g, "");
    var valid = /^\d{6}$/.test(number)
    if (/^\d+$/.test(number)) {
      input.value = number.match(/.{1,3}/g).join(" ")
    }
    return valid;
  }

  $("#email-for-reset input").focus(function(){
    $("#obtain_one_time_code_for_login, #login_with_one_time_code").hide()
  });

  $("#email-for-reset input").bind("focus blur keyup change", function(){
    if ($(this).val() == "") {
      $("#send-reset-link").hide();
      $("#phone-for-code input").removeAttr("disabled")
    } else {
      $("#send-reset-link").show();
      $("#phone-for-code input").attr("disabled", "disabled")
      $("#obtain_one_time_code_for_login, #login_with_one_time_code").hide()
      $("#phone-for-code input").attr("disabled", "disabled")
    }
  });


  $("#phone-for-code input").bind("focus blur keyup change", function(){
    if ($(this).val() == "") {
      $("#send-reset-link").hide();
      $("#email-for-reset input").removeAttr("disabled")
      $("#obtain_one_time_code_for_login").hide()
    } else {
      $("#email-for-reset input").attr("disabled", "disabled")
      $("#obtain_one_time_code_for_login").show()
      sanitizePhoneNumber(this)
    }
  })

  $("#one-time-code input").bind("focus blur keyup change", function(){
    sanitizeVerificationCode(this);
  })

  function obtainOneTimeCodeForLogin() {
    $("button#obtain_one_time_code_for_login").attr("disabled", "disabled")
    $.post(
      $(this).attr("remoteaction"), {phone: $("#phone-for-code input").val()},
      function(data) {
        console.log(data)
        if (data.success) {
          $("#login_with_one_time_code").show()
          $("button#obtain_one_time_code_for_login").hide()
          $("#one-time-code").show()
          $('.patientForm__groupError').hide()
          $('.patientForm__groupError').text("")
        } else {
          $('.patientForm__groupError').show()
          $('.patientForm__groupError').text(data.message)
        }
	$("button#obtain_one_time_code_for_login").removeAttr("disabled");
      }
    )
  }
  $("button#obtain_one_time_code_for_login").click(obtainOneTimeCodeForLogin);

  $("button#login_with_one_time_code").click(function(){
    $.post(
      $(this).attr("remoteaction"), {phone: $("#phone-for-code input").val(), code: $("#one-time-code input").val()},
      function(data) {
        console.log(data)
        if (data.success) {
          window.location.pathname = "/formularz/moje-formularze"
        } else {
          $('.patientForm__groupError').show()
          $('.patientForm__groupError').text(data.message)
        }
      }
    )
  });

  $("input.patientForm__groupInput").change(function(){
    if (this.value != '') {
      $(this).addClass('notEmpty')
    } else {
      $(this).removeClass('notEmpty')
    }
  });
  $("input.patientForm__groupInput").each(function(){
    if (this.value != '') {
      $(this).addClass('notEmpty')
    } else {
      $(this).removeClass('notEmpty')
    }
  });

})
